import React, { ReactElement } from 'react';
//import createReactClass from 'create-react-class';

interface Props {
    content: string;
    children?: ReactElement;
};

export const HtmlContent = ({ content }: Props) => {

    //const s = "return { render() { return rce('div', null, rce(components['Button'], {content: this.props.propA}), rce(components['Button'], {content: 'hardcoded content'})); } }"
    //const createComponentSpec = new Function("rce", "components", s);
    //const componentSpec = createComponentSpec(React.createElement, { /*"Button": Button*/ });
    //const component = React.createElement(createReactClass(componentSpec), { propA: "content from property" }, null);

    return (
        <div dangerouslySetInnerHTML={{ __html: content }}/>
    )
};

export default HtmlContent;